import React, { ChangeEvent, KeyboardEventHandler, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { encodeToBase64, getUrlParams, unsecuredCopyToClipboard } from "../../../Utils/general";

const Header = () => {

    //Calling t and i18n method from useTranslation hook 
    const { t , i18n } = useTranslation();
    const navigate = useNavigate();
    const lang = i18n.language;
    // Arabic [ar], Aramaic, Azeri, Dhivehi/Maldivian [dv], Hebrew [he], Kurdish (Sorani) [ku], Persian/Farsi [fa], Urdu [ur]
    const isRTL = ['ar','dv','he','ku','fa','ur'].includes(lang);

    const [ searchParam, setSearchParam ] = useState({
        searchIn: 'users',
        searchValue: ''
    });

    const searchHandler = () => {
        // if( searchParam?.searchValue === '' ) { return }
        let searchParams = location?.search === '' ? {} : getUrlParams(location?.search);
        console.log({searchParams})
        if( searchParam.searchIn === 'users' ) {
            let NewSearchObj = {...searchParams, q: (searchParam?.searchValue || '').trim()}
            navigate(`/admin/users?filter=${encodeToBase64(encodeURIComponent(JSON.stringify( NewSearchObj )))}`)
        }
        if( searchParam.searchIn === 'modals' ) {
            let NewSearchObj = {...searchParams, q: (searchParam?.searchValue || '').trim()}
            navigate(`/admin/modals?filter=${encodeToBase64(encodeURIComponent(JSON.stringify( NewSearchObj )))}`)
        }
    }

    const clearSearchHandler = () => {
        let searchParams = location?.search === '' ? {} : getUrlParams(location?.search);
        console.log({searchParams})
        if( searchParams?.['q'] ) {
            delete searchParams?.['q']
        }
        setSearchParam((prev)=>{
            return {
                ...prev,
                searchValue: ''
            }
        })
        if( JSON.stringify( searchParams ) === '{}' ) {
            navigate(`${location?.pathname}`)
        } else {
            navigate(`${location?.pathname}?filter=${encodeToBase64(encodeURIComponent(JSON.stringify( searchParams )))}`)
        }
    }

    return (
        <>
            <header className="mx-auto mt-4 w-10/12 min-h-10 bg-[#fff] flex flex-wrap rounded-3xl lg:rounded-full py-5 px-8">
                <div className="5xl:w-3/12 m-auto text-center xl:w-4/12 lg:w-5/12 md:w-6/12 sm:w-full order-1">
                    <div className="bg-[#015fe9] relative text-white font-bold inline-flex py-2 pl-4 pt-10 sm:pt-2 sm:pl-16 pr-4 md:rounded-full rounded-xl items-center whitespace-nowrap flex-col sm:flex-row mt-8 sm:mt-0 5xl:pr-6 5xl:pl-20 5xl:py-3">
                        <img className="absolute sm:left-[2px] sm:top-[2px] left-[35%] max-w-[40px] max-h-[40px] -top-4 5xl:top-3 h-full scale-[2.8] 5xl:scale-[4]" src="/assets/img/logo/iXr_logo.png" alt="iXr Logo" />
                        <span className="sm:mr-2 5xl:text-2xl">{t('interiorVerse')}</span>
                        <svg className="hidden mr-2 sm:block" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.312 15.392L15.2893 11.4147V0.394665H4.244L0.292 4.34667H8.652L1.22933 11.7693L3.91467 14.4547L11.312 7.05733V15.392Z" fill="white"></path></svg>
                        <svg className="hidden mr-2 sm:block" width="4" height="25" viewBox="0 0 4 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.646667 24.0667V0.759999H3.91467V24.0667H0.646667Z" fill="white"></path></svg>
                        <span className="5xl:text-2xl">{t('Admin Panel')}</span>
                    </div>
                </div>
                <div className="xl:w-4/12 min-w-[220px] mx-auto order-3 lg:w-5/12 md:w-6/12 xl:order-2 md:my-3">
                    <div className="bg-gradient-to-r from-[#c3c8fb] to-[#ecedfb] bg-opacity-95 relative text-white font-bold flex py-2 px-4 rounded-full lg:w-10/12  mx-auto items-center 5xl:py-3 5xl:px-10">
                        <svg className="mr-3" width="37" height="27" viewBox="0 0 37 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.57096 7.44727C4.13416 7.44727 3.76827 7.30327 3.4733 7.01527C3.1773 6.72827 3.0293 6.37227 3.0293 5.94727C3.0293 5.52227 3.1773 5.16577 3.4733 4.87777C3.76827 4.59077 4.13416 4.44727 4.57096 4.44727H9.19596C9.63277 4.44727 9.99917 4.59077 10.2952 4.87777C10.5901 5.16577 10.7376 5.52227 10.7376 5.94727C10.7376 6.37227 10.5901 6.72827 10.2952 7.01527C9.99917 7.30327 9.63277 7.44727 9.19596 7.44727H4.57096ZM4.57096 14.9473C4.13416 14.9473 3.76827 14.8033 3.4733 14.5153C3.1773 14.2283 3.0293 13.8723 3.0293 13.4473C3.0293 13.0223 3.1773 12.6658 3.4733 12.3778C3.76827 12.0908 4.13416 11.9473 4.57096 11.9473H9.19596C9.63277 11.9473 9.99917 12.0908 10.2952 12.3778C10.5901 12.6658 10.7376 13.0223 10.7376 13.4473C10.7376 13.8723 10.5901 14.2283 10.2952 14.5153C9.99917 14.8033 9.63277 14.9473 9.19596 14.9473H4.57096ZM30.6251 21.3973L25.7689 16.6723C25.1522 17.0973 24.478 17.4158 23.7462 17.6278C23.0134 17.8408 22.2744 17.9473 21.5293 17.9473C19.3967 17.9473 17.579 17.2158 16.0764 15.7528C14.5728 14.2908 13.821 12.5223 13.821 10.4473C13.821 8.37227 14.5728 6.60327 16.0764 5.14027C17.579 3.67827 19.3967 2.94727 21.5293 2.94727C23.6619 2.94727 25.4801 3.67827 26.9837 5.14027C28.4863 6.60327 29.2376 8.37227 29.2376 10.4473C29.2376 11.1723 29.1287 11.8913 28.9108 12.6043C28.6919 13.3163 28.364 13.9723 27.9272 14.5723L32.7835 19.2973C33.0661 19.5723 33.2074 19.9223 33.2074 20.3473C33.2074 20.7723 33.0661 21.1223 32.7835 21.3973C32.5008 21.6723 32.1411 21.8098 31.7043 21.8098C31.2675 21.8098 30.9078 21.6723 30.6251 21.3973ZM21.5293 14.9473C22.814 14.9473 23.906 14.5098 24.8053 13.6348C25.7046 12.7598 26.1543 11.6973 26.1543 10.4473C26.1543 9.19727 25.7046 8.13477 24.8053 7.25977C23.906 6.38477 22.814 5.94727 21.5293 5.94727C20.2446 5.94727 19.1526 6.38477 18.2533 7.25977C17.354 8.13477 16.9043 9.19727 16.9043 10.4473C16.9043 11.6973 17.354 12.7598 18.2533 13.6348C19.1526 14.5098 20.2446 14.9473 21.5293 14.9473ZM4.57096 22.4473C4.13416 22.4473 3.76827 22.3033 3.4733 22.0153C3.1773 21.7283 3.0293 21.3723 3.0293 20.9473C3.0293 20.5223 3.1773 20.1663 3.4733 19.8793C3.76827 19.5913 4.13416 19.4473 4.57096 19.4473H16.9043C17.3411 19.4473 17.7075 19.5913 18.0035 19.8793C18.2985 20.1663 18.446 20.5223 18.446 20.9473C18.446 21.3723 18.2985 21.7283 18.0035 22.0153C17.7075 22.3033 17.3411 22.4473 16.9043 22.4473H4.57096Z" fill="#3447FF"></path></svg>
                        <input 
                            type="text"
                            className="w-10/12 h-full outline-none bg-none border-none text-[#015fe9] placeholder-[#015fe9] text-lg 5xl:text-2xl font-medium"
                            placeholder="Search for a specific tag..."
                            style={{background: "none"}}
                            value={searchParam.searchValue}
                            onChange={(e: ChangeEvent<HTMLInputElement>)=>{
                                setSearchParam((prev)=>{
                                    return {
                                        ...prev,
                                        searchValue: e?.target?.value || ''
                                    }
                                })
                            }}
                            onKeyDown={(e)=>{
                                if( e.key === 'Enter' ) { searchHandler() }
                            }}
                            />
                            { searchParam.searchValue !== '' && <button
                                className="text-[#015fe9]"
                                onClick={()=>{
                                    clearSearchHandler()
                                }}
                            >&times;</button> }
                    </div>
                </div>
                <div className="5xl:w-2/12 xl:w-1/12 lg:w-2/12 w-full my-3 md:my-3 md:w-6/12 flex flex-row md:flex-col justify-center gap-5 md:gap-0 items-left order-2 xl:order-3 5xl:items-center 5xl:justify-around 5xl:aligns-start 5xl:flex-row">
                    <label className="flex justify-center xl:justify-start" htmlFor="users">
                        <input 
                            className="5xl:scale-[1.8]"
                            type="radio"
                            name="model"
                            id="users"
                            defaultChecked
                            onChange={(e)=>{
                                setSearchParam((prev)=>{
                                    return {
                                        ...prev,
                                        searchIn: 'users'
                                    }
                                })
                                // searchHandler()
                            }}
                        />
                        <h3 className="text-sm ml-2 font-semibold 5xl:text-2xl 5xl:ml-4">{ t('User') }</h3>
                    </label>
                    <label className="flex justify-center xl:justify-start" htmlFor="models">
                        <input
                            className="5xl:scale-[1.8]"
                            type="radio"
                            name="model"
                            id="models"
                            onChange={(e)=>{
                                setSearchParam((prev)=>{
                                    return {
                                        ...prev,
                                        searchIn: 'modals'
                                    }
                                })
                                // searchHandler()
                            }}
                        />
                        <h3 className="text-sm ml-2 font-semibold 5xl:text-2xl 5xl:ml-4">{ t('Model') }</h3>
                    </label>
                </div>
                <div className="mx-auto mt-6 mb-4 text-center xl:w-3/12 md:w-6/12 lg:hidden xl:block md:block w-full sm:w-6/12 md:my-3 order-4">
                    <Link to="https://interioxr.com/" target="_blank" rel="noopener noreferrer">
                        <div className="bg-[#3447FF] bg-opacity-70 relative text-white font-bold inline-flex py-2 pl-14 pr-4 rounded-full items-center 5xl:pl-20 5xl:py-3 5xl:pr-6">
                            <img
                                className="absolute left-[0px] top-[0px] h-full scale-[2.8]"
                                src="/assets/img/logo/iXr_logo1.png"
                                alt="ixr_logo"
                            />
                            <span className="5xl:text-2xl mr-2">{ t('interioXR.com') }</span>
                            <svg className="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.312 15.392L15.2893 11.4147V0.394665H4.244L0.292 4.34667H8.652L1.22933 11.7693L3.91467 14.4547L11.312 7.05733V15.392Z" fill="white"></path></svg>
                        </div>
                    </Link>
                </div>
            </header> 
        </>
    )
}

export default Header